export { EdpPackComponent } from "./edp-pack.component";
export {
    IPack,
    Pack,
    PackFactory,
    Component,
    ComponentFactory,
} from "./edp-pack.model";
